import { render, staticRenderFns } from "./WidgetCreateUpdateV2.vue?vue&type=template&id=24b9ad64"
import script from "./WidgetCreateUpdateV2.vue?vue&type=script&lang=js"
export * from "./WidgetCreateUpdateV2.vue?vue&type=script&lang=js"
import style0 from "./WidgetCreateUpdateV2.vue?vue&type=style&index=0&id=24b9ad64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports